import CreateNewStory from '@assets/images/create-new-story.png';
import NightWhisper from '@assets/images/nights_whisper_ic.png';
import DailyAdventure from '@assets/images/daily_adventure_ic.png';
import SelectEnding from '@assets/images/select-ending.png';
import WhatIf from '@assets/images/what-if.png';
import YouTellStory from '@assets/images/you-tell-story.png';
import { Col, Row } from 'antd';
import { Link } from 'react-router-dom';
import styles from './index.module.scss';
import { ToggleStory } from '@components';
import cs from 'classnames';
import { useStore } from '@store';

const MobileDashboard = () => {
  const { theme } = useStore();
  return (
    <div>
      <div className={styles['title']}>
        <h1> A World of Imagination for Your Kid</h1>
      </div>
      <div className={styles['create_story_container']}>
        <Link to={'/story'} className={styles['action_cards']}>
          <img src={CreateNewStory} alt="create new story" />
          <h3>Create Story</h3>
        </Link>
      </div>

      <div className={styles['color_cards_container']}>
        <Row gutter={[20, 20]} align={'stretch'}>
          <Col lg={6} xs={12}>
            <Link
              to={'#'}
              className={cs([styles['colored_cards'], styles['pink']])}>
              <img src={SelectEnding} alt="Select your ending" />
              <h3>Select your ending</h3>
            </Link>
          </Col>
          <Col lg={6} xs={12}>
            <Link
              to={'/dashboard/whatif'}
              className={cs([styles['colored_cards'], styles['yellow']])}>
              <img src={WhatIf} alt="What if" />
              <h3>What if</h3>
            </Link>
          </Col>
          <Col lg={6} xs={12}>
            <Link
              to={'#'}
              className={cs([styles['colored_cards'], styles['orange']])}>
              <img src={YouTellStory} alt="You tell story" />
              <h3>You tell story</h3>
            </Link>
          </Col>
          <Col lg={6} xs={12}>
            <Link
              to={'#'}
              className={cs([styles['colored_cards'], styles['blue']])}>
              <img
                src={theme === 'night' ? NightWhisper : DailyAdventure}
                alt="Night’s whisper"
              />
              <h3>
                {theme === 'night' ? 'Night’s whisper' : 'Daily adventures'}
              </h3>
            </Link>
          </Col>
        </Row>
      </div>
      {/* <div className={styles['toggle_container']}>
        <div className={styles['toggle']}>
          <ToggleStory />
        </div>
      </div> */}
    </div>
  );
};

export default MobileDashboard;
